module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/division/division.component.css
// module id = ./src/app/admin/lookup-management/division/division.component.css
// module chunks = main